<mat-dialog-content class="mat-body">
  This link may be invalid or you may be using an old version of Celo.
  <br />
  <br />
  Please update Celo and try again. If the problem persists, contact
  <a href="mailto:support@celohealth.com">support&#64;celohealth.com</a>
</mat-dialog-content>
